<template>
  <div class="grp-page" :class="device.desktop ? 'pa-6' : 'pa-0'">
    <v-row>
      <v-col cols="12">
        <v-card class="grp-card elevation-0">
          <div class="grp-toolbar">
            <div class="grp-toolbar__left">
              <div class="grp-toolbar__icon">
                <v-icon>mdi-account-group</v-icon>
              </div>
              <div>
                <div class="grp-toolbar__title">Tester Group WhatsApp</div>
                <div class="grp-toolbar__sub">
                  Muat daftar group dari sesi, lalu kirim pesan uji
                </div>
              </div>
            </div>
            <div class="grp-toolbar__actions">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                placeholder="Cari nama / ID group..."
                single-line
                hide-details
                dense
                outlined
                color="#1f7a57"
                class="grp-search"
                clearable
              ></v-text-field>
              <v-btn icon class="grp-icon-btn" :loading="loading" @click="loadGroups">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </div>
          </div>

          <div class="grp-panel">
            <div class="grp-field-label">Nomor Pengirim (sesi Terhubung)</div>
            <v-select
              outlined
              dense
              hide-details="auto"
              color="#1f7a57"
              item-color="#1f7a57"
              v-model="senderNumber"
              :items="senders"
              placeholder="Pilih nomor WhatsApp"
              class="grp-field mb-4"
              prepend-inner-icon="mdi-whatsapp"
              @change="onSenderChange"
            ></v-select>

            <div class="grp-actions-row mb-4">
              <v-btn
                class="grp-btn-primary"
                :loading="loading"
                :disabled="!senderNumber"
                @click="loadGroups"
              >
                <v-icon left small>mdi-refresh</v-icon>
                Muat Group
              </v-btn>
              <v-btn
                outlined
                color="#1f7a57"
                class="grp-btn-outline ml-2"
                :disabled="!senderNumber"
                @click="openSendDialog(null)"
              >
                <v-icon left small>mdi-send</v-icon>
                Kirim Manual (isi ID)
              </v-btn>
            </div>

            <v-alert
              v-if="errorText"
              dense
              text
              type="warning"
              class="mb-4"
            >
              {{ errorText }}
            </v-alert>

            <v-data-table
              v-show="device.desktop"
              :headers="headers"
              :items="filtered"
              :items-per-page="50"
              class="grp-table"
              :loading="loading"
              loading-text="Memuat daftar group..."
              hide-default-footer
            >
              <template v-slot:item.name="{ item }">
                <div class="grp-name">
                  <v-icon small color="#1f7a57" class="mr-1">mdi-account-group</v-icon>
                  {{ item.name || 'Tanpa nama' }}
                </div>
              </template>
              <template v-slot:item.id="{ value }">
                <span class="grp-id" :title="value">{{ value || '—' }}</span>
              </template>
              <template v-slot:item.participants="{ value }">
                {{ value != null ? value : '—' }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn
                  small
                  class="grp-btn-primary"
                  @click="openSendDialog(item)"
                >
                  <v-icon left small>mdi-send</v-icon>
                  Kirim
                </v-btn>
                <v-btn icon small class="ml-1" title="Salin ID" @click="copyId(item.id)">
                  <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
              </template>
              <template v-slot:no-data>
                <div class="grp-empty pa-8">
                  <v-icon size="48" color="#9bb5a8">mdi-account-group-outline</v-icon>
                  <div class="grp-empty__title">Belum ada group</div>
                  <div class="grp-empty__sub">
                    Pilih nomor pengirim yang Terhubung, lalu klik Muat Group
                  </div>
                </div>
              </template>
            </v-data-table>

            <div class="grp-mobile" v-show="device.mobile">
              <div
                v-for="item in filtered"
                :key="item.id"
                class="grp-mobile-card"
              >
                <div class="grp-mobile-card__title">{{ item.name || 'Group' }}</div>
                <div class="grp-id mt-1">{{ item.id }}</div>
                <div class="grp-mobile-card__meta mt-2">
                  Anggota: {{ item.participants != null ? item.participants : '—' }}
                </div>
                <div class="mt-3 d-flex">
                  <v-btn small class="grp-btn-primary" @click="openSendDialog(item)">
                    Kirim
                  </v-btn>
                  <v-btn small text color="#1f7a57" class="ml-2" @click="copyId(item.id)">
                    Salin ID
                  </v-btn>
                </div>
              </div>
              <div v-if="!filtered.length && !loading" class="grp-empty pa-8">
                <div class="grp-empty__title">Belum ada group</div>
                <div class="grp-empty__sub">Muat group dari sesi yang Terhubung</div>
              </div>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialog kirim -->
    <v-dialog v-model="sendOpen" max-width="560" persistent content-class="grp-dialog">
      <v-card class="grp-dialog-card">
        <div class="grp-dialog-header">
          <div class="grp-dialog-header__copy">
            <v-icon color="#1f7a57">mdi-send</v-icon>
            <div>
              <div class="grp-toolbar__title" style="font-size: 1.05rem">Kirim ke Group</div>
              <div class="grp-toolbar__sub">Pesan uji dari nomor terpilih</div>
            </div>
          </div>
          <v-btn icon @click="sendOpen = false"><v-icon>mdi-close</v-icon></v-btn>
        </div>

        <v-card-text class="grp-dialog-body">
          <div class="grp-field-label">Group ID</div>
          <v-text-field
            outlined
            dense
            color="#1f7a57"
            hide-details="auto"
            v-model="form.group_id"
            placeholder="1203630xxxxx@g.us"
            class="grp-field mb-4"
            prepend-inner-icon="mdi-identifier"
            @blur="loadParticipants"
          ></v-text-field>

          <div class="grp-mention-box mb-4">
            <div class="grp-mention-box__head">
              <div>
                <div class="grp-field-label mb-0">Mention (hanya group)</div>
                <div class="grp-toolbar__sub">Tag anggota agar mendapat notifikasi</div>
              </div>
              <v-switch
                v-model="form.mention_all"
                color="#1f7a57"
                dense
                hide-details
                class="mt-0 pt-0"
                label="Semua anggota"
                @change="onMentionAllChange"
              ></v-switch>
            </div>

            <v-btn
              small
              text
              color="#1f7a57"
              class="px-0 mb-2"
              :loading="loadingParticipants"
              :disabled="!form.group_id || !senderNumber"
              @click="loadParticipants"
            >
              <v-icon left small>mdi-account-multiple</v-icon>
              Muat anggota
            </v-btn>

            <v-select
              v-if="!form.mention_all"
              outlined
              dense
              multiple
              chips
              small-chips
              deletable-chips
              color="#1f7a57"
              item-color="#1f7a57"
              hide-details="auto"
              v-model="form.mentions"
              :items="participantItems"
              :loading="loadingParticipants"
              placeholder="Pilih anggota untuk di-mention"
              class="grp-field"
              prepend-inner-icon="mdi-at"
              no-data-text="Muat anggota group dulu"
            ></v-select>

            <div v-else class="grp-mention-hint">
              Semua anggota group akan di-mention otomatis.
            </div>
          </div>

          <div class="grp-field-label">Pesan</div>
          <v-textarea
            outlined
            dense
            color="#1f7a57"
            hide-details="auto"
            v-model="form.message"
            rows="4"
            auto-grow
            placeholder="Tulis pesan uji..."
            class="grp-field mb-2"
            prepend-inner-icon="mdi-message-text"
          ></v-textarea>

          <div v-if="lastResult" class="grp-result mt-3" :class="lastResult.ok ? 'is-ok' : 'is-fail'">
            {{ lastResult.text }}
          </div>
        </v-card-text>

        <v-divider class="grp-divider"></v-divider>
        <v-card-actions class="grp-dialog-actions">
          <v-btn text class="grp-btn-ghost" @click="sendOpen = false">Batal</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="grp-btn-primary"
            :loading="sending"
            @click="submitSend"
          >
            <v-icon left small>mdi-send</v-icon>
            Kirim Sekarang
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "PesanGroupTester",
  data() {
    return {
      senders: [],
      senderNumber: null,
      groups: [],
      search: "",
      loading: false,
      sending: false,
      errorText: "",
      sendOpen: false,
      lastResult: null,
      loadingParticipants: false,
      participants: [],
      form: {
        group_id: "",
        message: "Halo dari SenderWA (tester group)",
        mention_all: false,
        mentions: [],
      },
      headers: [
        { text: "Nama Group", value: "name", sortable: true },
        { text: "Group ID", value: "id", sortable: false },
        { text: "Anggota", value: "participants", width: 100 },
        { text: "Aksi", value: "actions", sortable: false, width: 160, align: "end" },
      ],
    };
  },
  computed: {
    ...mapState(["http", "device", "snackbar"]),
    filtered() {
      const q = String(this.search || "").toLowerCase().trim();
      if (!q) return this.groups || [];
      return (this.groups || []).filter((g) => {
        return (
          String(g.name || "").toLowerCase().includes(q) ||
          String(g.id || "").toLowerCase().includes(q)
        );
      });
    },
    participantItems() {
      return (this.participants || []).map((p) => ({
        text: `${p.name || p.phone || p.id}${p.phone ? " · " + p.phone : ""}`,
        value: p.id,
      }));
    },
  },
  created() {
    this.setPage({
      crud: false,
      dataUrl: "api/pesan/groups",
      title: "TESTER GROUP",
      subtitle: "Kirim pesan uji ke WhatsApp group",
      showtable: false,
      breadcrumbs: [
        { text: "Pesan", disabled: true, href: "" },
        { text: "Tester Group", disabled: false, href: "" },
      ],
      actions: { refresh: true, add: false, edit: false, delete: false },
    });
    this.loadCombos();
  },
  methods: {
    ...mapActions(["setPage"]),
    async loadCombos() {
      try {
        const { data } = await this.http.get("api/combo/pengaturan");
        this.senders = data || [];
        if (!this.senderNumber && this.senders.length) {
          this.senderNumber = this.senders[0].value;
        }
      } catch (e) {
        this.senders = [];
      }
    },
    onSenderChange() {
      this.groups = [];
      this.errorText = "";
    },
    async loadGroups() {
      if (!this.senderNumber) {
        this.snack(false, "Pilih nomor pengirim dulu");
        return;
      }
      this.loading = true;
      this.errorText = "";
      try {
        const { data } = await this.http.get("api/pesan/groups", {
          params: { sender_number: this.senderNumber },
        });
        if (data && data.success === false) {
          this.groups = [];
          this.errorText = data.message || "Gagal memuat group";
          this.snack(false, this.errorText);
          return;
        }
        this.groups = Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : [];
        this.snack(true, `${this.groups.length} group dimuat`);
      } catch (e) {
        this.groups = [];
        const msg =
          (e.response && e.response.data && e.response.data.message) ||
          e.message ||
          "Gagal memuat group";
        this.errorText = msg;
        this.snack(false, msg);
      } finally {
        this.loading = false;
      }
    },
    openSendDialog(item) {
      this.lastResult = null;
      this.participants = [];
      this.form = {
        group_id: item && item.id ? String(item.id) : "",
        message: "Halo dari SenderWA (tester group)",
        mention_all: false,
        mentions: [],
      };
      this.sendOpen = true;
      if (this.form.group_id) {
        this.loadParticipants();
      }
    },
    onMentionAllChange() {
      if (this.form.mention_all) {
        this.form.mentions = [];
      }
    },
    async loadParticipants() {
      if (!this.senderNumber || !(this.form.group_id || "").trim()) return;
      this.loadingParticipants = true;
      try {
        const { data } = await this.http.get("api/pesan/groups/participants", {
          params: {
            sender_number: this.senderNumber,
            group_id: this.form.group_id.trim(),
          },
        });
        this.participants = Array.isArray(data?.data) ? data.data : [];
        if (!this.participants.length) {
          this.snack(false, (data && data.message) || "Anggota tidak ditemukan");
        }
      } catch (e) {
        this.participants = [];
        const msg =
          (e.response && e.response.data && e.response.data.message) ||
          e.message ||
          "Gagal memuat anggota";
        this.snack(false, msg);
      } finally {
        this.loadingParticipants = false;
      }
    },
    async submitSend() {
      if (!this.senderNumber) {
        this.snack(false, "Pilih nomor pengirim");
        return;
      }
      if (!(this.form.group_id || "").trim()) {
        this.snack(false, "Isi Group ID");
        return;
      }
      if (!(this.form.message || "").trim()) {
        this.snack(false, "Isi pesan");
        return;
      }

      this.sending = true;
      this.lastResult = null;
      try {
        const { data } = await this.http.post("api/pesan/groups/send", {
          sender_number: this.senderNumber,
          group_id: this.form.group_id.trim(),
          message: this.form.message.trim(),
          mention_all: !!this.form.mention_all,
          mentions: this.form.mention_all ? [] : this.form.mentions || [],
        });

        if (data && data.success) {
          const mentionInfo = data.data && data.data.mention_all
            ? " + mention semua"
            : data.data && data.data.mentions && data.data.mentions.length
              ? ` + ${data.data.mentions.length} mention`
              : "";
          this.lastResult = {
            ok: true,
            text:
              "Terkirim ke " +
              ((data.data && data.data.group_id) || this.form.group_id) +
              mentionInfo,
          };
          this.snack(true, "Pesan group terkirim");
        } else {
          this.lastResult = {
            ok: false,
            text: (data && data.message) || "Gagal mengirim",
          };
          this.snack(false, this.lastResult.text);
        }
      } catch (e) {
        const msg =
          (e.response && e.response.data && e.response.data.message) ||
          e.message ||
          "Gagal mengirim ke group";
        this.lastResult = { ok: false, text: msg };
        this.snack(false, msg);
      } finally {
        this.sending = false;
      }
    },
    async copyId(id) {
      try {
        await navigator.clipboard.writeText(String(id || ""));
        this.snack(true, "Group ID disalin");
      } catch (e) {
        this.snack(false, "Gagal menyalin");
      }
    },
    snack(ok, text) {
      this.snackbar.color = ok ? "success" : "error";
      this.snackbar.text = text;
      this.snackbar.state = true;
    },
  },
};
</script>

<style scoped>
.grp-page {
  --gw-green: #1f7a57;
  --gw-green-soft: #e8f5ef;
  --gw-ink: #163529;
  --gw-muted: #5d7268;
  --gw-line: #d7e5dd;
  --gw-bg: #f4faf7;
}

.grp-card {
  background: #fff;
  border: 1px solid var(--gw-line);
  border-radius: 16px;
  overflow: hidden;
}

.grp-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 20px;
  border-bottom: 1px solid var(--gw-line);
  background: linear-gradient(180deg, #fff 0%, var(--gw-bg) 100%);
}

.grp-toolbar__left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.grp-toolbar__icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: var(--gw-green-soft);
  display: flex;
  align-items: center;
  justify-content: center;
}

.grp-toolbar__icon .v-icon {
  color: var(--gw-green) !important;
}

.grp-toolbar__title {
  font-weight: 700;
  color: var(--gw-ink);
  font-size: 1.1rem;
}

.grp-toolbar__sub {
  color: var(--gw-muted);
  font-size: 0.85rem;
}

.grp-toolbar__actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.grp-search {
  min-width: 220px;
  max-width: 280px;
}

.grp-search >>> .v-input__slot {
  background: #fff;
}

.grp-panel {
  padding: 20px;
}

.grp-field-label {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--gw-muted);
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.grp-field >>> .v-input__slot {
  background: #fff;
}

.grp-actions-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.grp-btn-primary {
  background: var(--gw-green) !important;
  color: #fff !important;
  text-transform: none !important;
  font-weight: 600 !important;
  box-shadow: none !important;
}

.grp-btn-outline {
  text-transform: none !important;
  font-weight: 600 !important;
}

.grp-btn-ghost {
  text-transform: none !important;
  color: var(--gw-muted) !important;
}

.grp-icon-btn:hover {
  color: var(--gw-green) !important;
}

.grp-table >>> thead th {
  background: var(--gw-bg) !important;
  color: var(--gw-muted) !important;
  font-weight: 700 !important;
  font-size: 0.78rem !important;
  border-bottom: 1px solid var(--gw-line) !important;
}

.grp-table >>> tbody td {
  border-bottom: 1px solid var(--gw-line) !important;
}

.grp-name {
  display: flex;
  align-items: center;
  font-weight: 600;
  color: var(--gw-ink);
}

.grp-id {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.78rem;
  color: var(--gw-muted);
  word-break: break-all;
}

.grp-empty {
  text-align: center;
  color: var(--gw-muted);
}

.grp-empty__title {
  font-weight: 700;
  color: var(--gw-ink);
  margin-top: 8px;
}

.grp-empty__sub {
  font-size: 0.9rem;
  margin-top: 4px;
}

.grp-mobile {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.grp-mobile-card {
  border: 1px solid var(--gw-line);
  border-radius: 12px;
  padding: 14px;
  background: #fff;
}

.grp-mobile-card__title {
  font-weight: 700;
  color: var(--gw-ink);
}

.grp-mobile-card__meta {
  font-size: 0.85rem;
  color: var(--gw-muted);
}

.grp-dialog-card {
  border-radius: 16px !important;
  overflow: hidden;
}

.grp-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 18px;
  border-bottom: 1px solid var(--gw-line);
  background: var(--gw-bg);
}

.grp-dialog-header__copy {
  display: flex;
  align-items: center;
  gap: 12px;
}

.grp-dialog-body {
  padding-top: 18px !important;
}

.grp-dialog-actions {
  padding: 12px 16px;
}

.grp-divider {
  border-color: var(--gw-line) !important;
}

.grp-mention-box {
  border: 1px solid var(--gw-line);
  border-radius: 12px;
  padding: 12px 14px;
  background: var(--gw-bg);
}

.grp-mention-box__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.grp-mention-hint {
  font-size: 0.85rem;
  color: var(--gw-muted);
}

.grp-result {
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 0.9rem;
}

.grp-result.is-ok {
  background: var(--gw-green-soft);
  color: var(--gw-green);
}

.grp-result.is-fail {
  background: #fdecea;
  color: #b71c1c;
}

@media (max-width: 600px) {
  .grp-toolbar {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
